module.exports = __webpack_public_path__ + "img/oculus_hifi_7.08fcb474.png";